import { useEffect } from 'react';
import { API } from '@shared/types/api';
import { useViewTemplates } from './useViewTemplates';

export function useAllViewTemplates(
  workflowTemplateId?: string | null,
  type?: API.ViewType,
  subtype?: API.ViewSubtype,
  name?: string,
  isPublic?: boolean,
  skip?: boolean,
): {
  viewTemplates: API.ViewTemplateFragment[];
  loading: boolean;
  error?: Error;
} {
  const { viewTemplates, hasMore, fetchMore, loading, moreLoading, error } = useViewTemplates({
    workflowTemplateId,
    type,
    subtype,
    name,
    isPublic,
    skip,
  });

  useEffect(() => {
    if (hasMore && !moreLoading && viewTemplates.length > 0) {
      fetchMore();
    }
  }, [fetchMore, hasMore, moreLoading, viewTemplates.length]);

  return {
    viewTemplates,
    loading: loading || moreLoading,
    error,
  };
}
